import React from 'react';
import { Section } from './ui/Section';
import { FileText, BookOpen, Printer, Calendar, LifeBuoy, Clock } from 'lucide-react';
export function Includes() {
  const items = [{
    icon: FileText,
    text: 'PDF completo "Calma Espiritual (7 días)"'
  }, {
    icon: Calendar,
    text: 'Guía día por día (mañana + noche)'
  }, {
    icon: Printer,
    text: 'Plantillas imprimibles (journaling guiado)'
  }, {
    icon: BookOpen,
    text: 'Tracker de 7 días'
  }, {
    icon: LifeBuoy,
    text: 'Plan B de 2 minutos (para crisis y días imposibles)'
  }, {
    icon: Clock,
    text: 'Ritual mínimo de 3 minutos para mantener'
  }];
  return <Section data-id="element-64">
      <h2 className="text-3xl font-serif mb-10 text-center text-warm-brown" data-id="element-65">
        Qué incluye
      </h2>

      <div className="grid grid-cols-1 md:grid-cols-2 gap-6" data-id="element-66">
        {items.map((item, index) => <div key={index} className="flex items-start gap-4 p-4 rounded-lg hover:bg-white/50 transition-colors" data-id="element-67">
            <div className="text-gold mt-1" data-id="element-68">
              <item.icon size={24} strokeWidth={1.5} data-id="element-69" />
            </div>
            <span className="text-lg text-warm-brown/90" data-id="element-70">{item.text}</span>
          </div>)}
      </div>
    </Section>;
}